import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AuthService, User } from '../../../core/service/auth/auth.service';

const PAGE_TITLES: Record<string, string> = {
  'actualites':                  'Actualités',
  'communiques':                 'Communiqués',
  'revues-presse':               'Revues de presse',
  'mediatique':                  'Médiathèque',
  'formulaires':                 'Formulaires',
  'partenaires':                 'Partenaires',
  'documents-publics':           'Documents publics',
  'evenements-historiques':      'Événements historiques',
  'instances-internationales':   'Instances internationales',
  'members':                     'Membres',
  'bureau-executif':             'Bureau Exécutif',
  'administration':              'Administration',
  'content-manager':             'Contenu des pages',
  'reunions':                    'Réunions',
  'reseaux-sociaux':             'Réseaux sociaux',
};

const PAGE_SUBTITLES: Record<string, string> = {
  'actualites':                  'Gestion des articles et publications',
  'communiques':                 'Gestion des communiqués officiels',
  'revues-presse':               'Suivi des articles de presse',
  'mediatique':                  'Galeries photos et vidéos',
  'formulaires':                 'Gestion des formulaires officiels',
  'partenaires':                 'Logos et partenaires officiels',
  'documents-publics':           'Statuts, règlements et rapports',
  'evenements-historiques':      'Frise chronologique de la fédération',
  'instances-internationales':   'Affiliations et instances mondiales',
  'members':                     'Annuaire des membres de la fédération',
  'bureau-executif':             'Membres du bureau fédéral',
  'administration':              'Gestion des commissions administratives',
  'content-manager':             'Édition du contenu des pages web',
  'reunions':                    'Planification et suivi des réunions',
  'reseaux-sociaux':             'Liens vers les plateformes sociales',
};

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  currentUser: User | null = null;
  federationName = '';
  pageTitle = '';
  pageSubtitle = '';

  private destroy$ = new Subject<void>();

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    this.authService.currentUser$.pipe(takeUntil(this.destroy$)).subscribe(user => {
      this.currentUser = user;
    });
    const federation = this.authService.getFederation();
    this.federationName = federation?.federation_name || 'Fédération';

    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe((e: any) => {
      this.resolvePage(e.urlAfterRedirects || e.url);
    });

    this.resolvePage(this.router.url);
  }

  ngOnDestroy(): void { this.destroy$.next(); this.destroy$.complete(); }

  private resolvePage(url: string): void {
    const segment = url.split(/[?#]/)[0].split('/').filter(Boolean)[1] || '';
    this.pageTitle    = PAGE_TITLES[segment]    || this.federationName;
    this.pageSubtitle = PAGE_SUBTITLES[segment] || '';
  }

  logout(): void {
    this.authService.logout().subscribe({
      next: () => this.router.navigate(['/federation/login']),
      error: () => this.router.navigate(['/federation/login'])
    });
  }
}
